import React from "react";
import { fotosDe } from "../../data/portafolio";
import FotoMosaico from "./FotoMosaico";
import FondoEstudio from "./FondoEstudio";
import WhatsAppCta from "./WhatsAppCta";

/* `fotos` reemplaza las del segmento cuando la página muestra un subconjunto
   (la revelación de sexo, que son fotos de eventos con su etiqueta). */
const FotoGaleria = ({ segmentoId, nombre, whatsapp, fotos }) => {
  const items = fotos || fotosDe(segmentoId);

  /*
    Sin fotos propias no se pinta una rejilla de marcadores: tres rectángulos
    grises en la web de un fotógrafo se leen como imágenes que no cargaron, no
    como "en preparación". Se dice en una línea qué falta y se ofrece la vía
    por la que un interesado sí puede ver trabajo hoy.
  */
  if (!items.length) {
    return (
      <section
        id="galeria"
        className="relative overflow-hidden bg-navy-900 py-20 text-white md:py-28"
      >
        <FondoEstudio variante="lateral" />
        <div className="container-page relative z-10">
          <h2 className="font-display text-display-sm font-bold">Trabajos de {nombre.toLowerCase()}.</h2>
          <p className="mt-4 max-w-xl text-navy-100">
            Esta galería se publica con fotografías propias del estudio, no con banco de imágenes.
            Mientras se carga, el precio y el plazo de esta página están vigentes.
          </p>
          {whatsapp ? (
            <WhatsAppCta message={whatsapp} location="galeria_vacia" variant="outline" className="mt-8">
              Pedir ejemplos por WhatsApp
            </WhatsAppCta>
          ) : null}
        </div>
      </section>
    );
  }

  return (
    <section id="galeria" className="bg-navy-900 py-20 text-white md:py-28">
      <div className="container-page">
        <h2 className="font-display text-display-sm font-bold">Trabajos de {nombre.toLowerCase()}.</h2>
        <FotoMosaico fotos={items} className="mt-10" />
      </div>
    </section>
  );
};

export default FotoGaleria;
